/* KBM text fixes - removes unwanted phrases + fixes search prices + hero search overflow */
(function(){
  function clean(){
    document.querySelectorAll('div[style*="#B04440"], div[style*="#fef0ee"]').forEach(function(el){
      if (el.innerHTML && /For brands and manufacturers only/i.test(el.innerHTML)) {
        el.innerHTML = el.innerHTML.replace(/\.?\s*For brands and manufacturers only\.?/gi, '.');
      }
    });
    document.querySelectorAll('.kbm-ugc-submit__copy p').forEach(function(p){
      if (!p.innerHTML) return;
      var html = p.innerHTML;
      var changed = false;
      if (/#KBMFabrics/i.test(html)) {
        html = html
          .replace(/\s*or\s+use\s*<strong>#KBMFabrics<\/strong>\s*\.?/i, '')
          .replace(/\s*or\s+use\s*#KBMFabrics\s*\.?/i, '');
        changed = true;
      }
      var before = html;
      html = html.replace(/(>@kbmfabrics<\/a>)\s*\.?\s*(Or\s+)/i, '$1 or ');
      html = html.replace(/(>@kbmfabrics<\/a>)\s*\.\s*$/i, '$1');
      if (before !== html) changed = true;
      if (changed) p.innerHTML = html;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  else clean();
  setTimeout(clean, 500);

  /* HERO SEARCH: fix cents-as-dollars bug */
  function fixHeroSearchPrices(){
    document.querySelectorAll('.kbm-hero-search-suggest .khs-price').forEach(function(el){
      var match = el.textContent.match(/\$([0-9]+(?:\.[0-9]+)?)/);
      if (!match) return;
      var val = parseFloat(match[1]);
      if (val > 0 && val < 1) {
        var fixed = (val * 100).toFixed(2);
        el.textContent = el.textContent.replace(/\$[0-9]+(?:\.[0-9]+)?/, '$' + fixed);
      }
    });
  }

  /* HERO SEARCH: simple overflow toggle so dropdown isn't clipped by hero overflow:hidden */
  function setupHeroSearch(){
    var hero = document.getElementById('kbmHero');
    var input = document.querySelector('.kbm-hero-search-input');
    var box = document.querySelector('.kbm-hero-search-suggest');
    if (!hero || !input || !box) return;

    function openOverflow(){ hero.classList.add('kbm-search-open'); }
    function closeOverflow(){
      setTimeout(function(){
        if (box.hidden) hero.classList.remove('kbm-search-open');
      }, 250);
    }

    input.addEventListener('focus', openOverflow);
    input.addEventListener('input', openOverflow);
    input.addEventListener('blur', closeOverflow);
    document.addEventListener('click', function(e){
      var form = input.closest('form');
      if (form && !form.contains(e.target)) closeOverflow();
    });

    if (window.MutationObserver) {
      var mo = new MutationObserver(function(){ fixHeroSearchPrices(); });
      mo.observe(box, { childList: true, subtree: true });
      fixHeroSearchPrices();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHeroSearch);
  else setupHeroSearch();
})();
